import styles from './FilterPanel.module.css'
import { LocationSettingsIcon } from 'shared/icons/LocationSettingsIcon'
import classNames from 'classnames'
import { FilterForm } from '../../FilterForm'
import { filtersToString } from 'shared/lib/filtersToString'
import { ApplyButton } from '../ApplyButton'

interface FilterPanelProps {
    expanded: boolean
    className?: string
    filters?: any
    onSummaryClick?: (event: any) => void
    onFiltersChange?: (event: any) => void
}

export const FilterPanel = (props: FilterPanelProps): JSX.Element => {
    const {
        expanded = false,
        className,
        filters,
        onSummaryClick,
        onFiltersChange
    } = props

    const handleButtonClick = (event: any) => {
        onSummaryClick?.(event)
    }

    const spyLaunchSettingsPanelClasses= classNames(styles.FilterPanel, className, {
        [styles[`FilterPanel--Expanded`]]: expanded,
    })

    const filterPanelSummaryButtonClasses = classNames(styles.SummaryButton, className, {
        [styles[`SummaryButton--Active`]]: expanded,
        [styles[`SummaryButton--HasValue`]]: filters !== undefined
    })

    const FilterPanelDetailsClasses = classNames(styles.FilterPanel__Details, {
        [styles[`FilterPanel__Details--Expanded`]]: expanded,
    })

    const renderValue = (): JSX.Element => {
        if (filters === undefined){
            return (
                <></>
            )
        }

        const valueString = filtersToString(filters)

        return (
            <span className={styles.FilterPanel__ValueContainer}>
                <span className={styles.FilterPanel__ValueCaption}>
                    {valueString}
                </span>
            </span>
        )
    }

    const handleFilterFormFilterChange = (event: any) => {
        onFiltersChange?.(event)
    } 
  
    return (
        <div className={spyLaunchSettingsPanelClasses}>
            <div 
                className={styles.FilterPanel__Summary}             
            >
                <button
                    className={filterPanelSummaryButtonClasses}  
                    onClick={handleButtonClick}           
                >
                    <span className={styles.SummaryButton__HelperContainer}>
                        <span className={styles.SummaryButton__IconContainer}>
                            <LocationSettingsIcon className={styles.SummaryButton__Icon} />
                        </span>
                        <span className={styles.SummaryButton__Caption}>
                            Filters
                        </span>               
                    </span>
                    {
                        renderValue()
                    }
                </button>
            </div>
            <div className={FilterPanelDetailsClasses}>
                <FilterForm 
                    filters={filters}
                    onFiltersChange={handleFilterFormFilterChange}
                />
                <div className={styles.FilterPanel__DetailsEndContainer}>
                    {/* <ApplyButton 
                        onClick={} 
                    /> */}
                </div>
            </div>
        </div>
    )
}